var render = function render(){var _vm=this,_c=_vm._self._c;return (!!_vm.phaseData)?_c('div',[_c('field-label',{staticClass:"mt-8",attrs:{"label":"Anotações"}},[_c('text-area',{key:'notes' + _vm.phaseKey,attrs:{"readonly":_vm.disabled,"max-length":2000},model:{value:(_vm.phaseData.notes),callback:function ($$v) {_vm.$set(_vm.phaseData, "notes", $$v)},expression:"phaseData.notes"}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }